/*
  boleta-factura.js v3 — production hardened
  Captura datos boleta/factura → cart.attributes via Shopify Ajax API.

  Cambios v3 (2026-05-11) — preparación migración Bsale:
  - Códigos SII estándar en todo el flow (33 factura, 39 boleta) — sin conversión a strings
  - Event delegation para checkout buttons (mata race conditions del bindCheckout)
  - fetch keepalive con FormData (más confiable que sendBeacon JSON en Safari iOS)
  - Source of truth = /cart.js (no sessionStorage) — drawer y /cart sincronizados
  - Acepta legacy strings ("factura"/"boleta") al cargar — backward compat con orders viejos
*/
if (!window.__BF_LOADED__) {
  window.__BF_LOADED__ = true;
  (function() {
    'use strict';

    var MAX_RETRIES = 3;
    var BASE_RETRY_DELAY = 300;
    var SS_KEY = 'bf_buffer_v3'; // sessionStorage buffer para inputs en vuelo

    function getEl(id) { return document.getElementById(id); }

    function fmtRut(v) {
      var c = v.replace(/[^0-9kK]/g, '').toUpperCase();
      if (c.length < 2) return c;
      return c.slice(0, -1).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + '-' + c.slice(-1);
    }

    function chkRut(r) {
      r = r.replace(/\./g, '').replace('-', '');
      if (r.length < 7) return false;
      var b = r.slice(0, -1);
      var dv = r.slice(-1).toUpperCase();
      var s = 0, m = 2;
      for (var i = b.length - 1; i >= 0; i--) {
        s += parseInt(b[i], 10) * m;
        m = m === 7 ? 2 : m + 1;
      }
      var x = 11 - (s % 11);
      return dv === (x === 11 ? '0' : x === 10 ? 'K' : String(x));
    }

    function debounce(fn, ms) {
      var timer;
      return function() {
        clearTimeout(timer);
        timer = setTimeout(fn, ms || 300);
      };
    }

    function getDocType() {
      var checked = document.querySelector('input[name="attributes[billing_document_type]"]:checked');
      return checked ? checked.value : '39'; // default boleta
    }

    function isInvoice() {
      return getDocType() === '33';
    }

    function getInputs() {
      return {
        rut: getEl('bf-rut'),
        company: getEl('bf-company'),
        giro: getEl('bf-giro'),
        rutErr: getEl('bf-rut-error'),
        compErr: getEl('bf-company-error'),
        giroErr: getEl('bf-giro-error'),
        topErr: getEl('bf-form-error'),
        invoiceBox: getEl('bf-invoice-fields')
      };
    }

    function showInvoiceFields() {
      var els = getInputs();
      if (!els.invoiceBox) return;
      var show = isInvoice();
      els.invoiceBox.style.display = show ? 'block' : 'none';
      [els.rut, els.company, els.giro].forEach(function(f) {
        if (f) f.required = show;
      });
    }

    // Sincroniza la clase .is-checked en los pill labels (reemplazo de :has en CSS,
    // que no funciona en Safari iOS < 15.4)
    function updateRadioVisuals() {
      var opts = document.querySelectorAll('.bf-radio-option');
      for (var i = 0; i < opts.length; i++) {
        var inp = opts[i].querySelector('input[type="radio"]');
        if (inp && inp.checked) opts[i].className = opts[i].className.replace(/\s*\bis-checked\b/g, '') + ' is-checked';
        else opts[i].className = opts[i].className.replace(/\s*\bis-checked\b/g, '');
      }
    }

    // Dispara un Event('change') compatible con browsers viejos (sin Event constructor)
    function fireChange(el) {
      var evt;
      try { evt = new Event('change', { bubbles: true }); }
      catch (e) {
        evt = document.createEvent('Event');
        evt.initEvent('change', true, true);
      }
      el.dispatchEvent(evt);
    }

    function buildAttrs() {
      var els = getInputs();
      var isInv = isInvoice();
      return {
        billing_document_type: getDocType(), // siempre '33' o '39' (códigos SII)
        billing_rut: isInv && els.rut ? fmtRut(els.rut.value) : '',
        billing_company_name: isInv && els.company ? els.company.value.trim() : '',
        billing_business_type: isInv && els.giro ? els.giro.value.trim() : ''
      };
    }

    function toggleCheckoutBtns(ok) {
      var btns = document.querySelectorAll('[name="checkout"], a[href$="/checkout"]');
      btns.forEach(function(el) {
        el.style.pointerEvents = ok ? 'auto' : 'none';
        el.style.opacity = ok ? '1' : '0.65';
        el.setAttribute('aria-disabled', !ok);
        if (el.tagName === 'BUTTON' || el.tagName === 'INPUT') el.disabled = !ok;
      });
    }

    function validateAll(final) {
      var ok = true;
      var els = getInputs();

      if (isInvoice()) {
        var okRut = els.rut ? chkRut(els.rut.value) : false;
        var okComp = els.company ? els.company.value.trim().length >= 3 : false;
        var okGiro = els.giro ? els.giro.value.trim().length >= 3 : false;
        ok = okRut && okComp && okGiro;

        function showErr(el, eEl, valid) {
          if (!el || !eEl) return;
          var show = !valid && (final || (el.value && el.dataset.hasBlurred === 'true'));
          eEl.style.display = show ? 'block' : 'none';
          el.classList.toggle('input-error', show);
        }
        showErr(els.rut, els.rutErr, okRut);
        showErr(els.company, els.compErr, okComp);
        showErr(els.giro, els.giroErr, okGiro);
      } else {
        [els.rutErr, els.compErr, els.giroErr].forEach(function(e) {
          if (e) e.style.display = 'none';
        });
        [els.rut, els.company, els.giro].forEach(function(e) {
          if (e) e.classList.remove('input-error');
        });
      }

      if (els.topErr) {
        els.topErr.style.display = (final && !ok && isInvoice()) ? 'block' : 'none';
      }

      toggleCheckoutBtns(ok);
      return ok;
    }

    // Push cart attributes — FormData con fetch keepalive
    function pushCartAttributes(retryCount) {
      var count = retryCount || 0;
      var attrs = buildAttrs();
      var formData = new FormData();
      Object.keys(attrs).forEach(function(k) {
        formData.append('attributes[' + k + ']', attrs[k]);
      });

      return fetch('/cart/update.js', {
        method: 'POST',
        body: formData,
        keepalive: true,
        credentials: 'same-origin'
      }).then(function(response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.json();
      }).catch(function(err) {
        if (count < MAX_RETRIES - 1) {
          var delay = BASE_RETRY_DELAY * Math.pow(2, count);
          return new Promise(function(resolve, reject) {
            setTimeout(function() {
              pushCartAttributes(count + 1).then(resolve).catch(reject);
            }, delay);
          });
        }
        throw err;
      });
    }

    // Buffer en sessionStorage para datos en vuelo (no perderlos al re-render)
    function saveBuffer() {
      try {
        var els = getInputs();
        var data = {
          docType: getDocType(),
          rut: els.rut ? els.rut.value : '',
          company: els.company ? els.company.value : '',
          giro: els.giro ? els.giro.value : '',
          ts: Date.now()
        };
        sessionStorage.setItem(SS_KEY, JSON.stringify(data));
      } catch(e) {}
    }

    function readBuffer() {
      try {
        var raw = sessionStorage.getItem(SS_KEY);
        if (!raw) return null;
        var data = JSON.parse(raw);
        // Buffer válido por 60s (después confiar 100% en /cart.js)
        if (!data.ts || (Date.now() - data.ts) > 60000) {
          sessionStorage.removeItem(SS_KEY);
          return null;
        }
        return data;
      } catch(e) { return null; }
    }

    function clearBuffer() {
      try { sessionStorage.removeItem(SS_KEY); } catch(e) {}
    }

    var safePush = debounce(function() {
      pushCartAttributes(0).then(clearBuffer).catch(function() {});
    }, 250);

    // Carga el estado: /cart.js es source of truth, sessionStorage solo cubre el gap
    // del debounce (datos tipeados pero no pusheados todavía cuando hubo un re-render)
    function loadStateFromCart() {
      return fetch('/cart.js', { credentials: 'same-origin' })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var els = getInputs();
          var docTypeRadios = document.querySelectorAll('input[name="attributes[billing_document_type]"]');
          var attrs = cart.attributes || {};
          var buffer = readBuffer();

          // Acepta códigos nuevos (33/39) o legacy strings (factura/boleta)
          var rawDoc = attrs.billing_document_type;
          var docType = '39';
          if (rawDoc === '33' || rawDoc === 'factura') docType = '33';
          else if (rawDoc === '39' || rawDoc === 'boleta') docType = '39';

          // Si hay buffer con datos más completos que /cart.js, usar buffer
          // (esto cubre el caso "tipeé factura + RUT y se re-renderizó el form")
          if (buffer && buffer.docType === '33' && buffer.rut && !attrs.billing_rut) {
            docType = buffer.docType;
            docTypeRadios.forEach(function(r) { r.checked = r.value === docType; });
            if (els.rut) els.rut.value = buffer.rut || '';
            if (els.company) els.company.value = buffer.company || '';
            if (els.giro) els.giro.value = buffer.giro || '';
            // Re-push para sincronizar /cart.js con el buffer
            pushCartAttributes(0).then(clearBuffer).catch(function() {});
          } else {
            docTypeRadios.forEach(function(r) { r.checked = r.value === docType; });
            if (els.rut) els.rut.value = attrs.billing_rut || '';
            if (els.company) els.company.value = attrs.billing_company_name || '';
            if (els.giro) els.giro.value = attrs.billing_business_type || '';
          }

          showInvoiceFields();
          updateRadioVisuals();
          validateAll(false);
        })
        .catch(function() {});
    }

    // Event delegation para checkout buttons (capturing phase para ganar a otros listeners)
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('a[href$="/checkout"], button[name="checkout"], input[name="checkout"]');
      if (!btn) return;

      // Si el módulo no está montado en el DOM, dejar pasar el click natural
      if (!document.querySelector('.boleta-factura-wrapper')) return;

      e.preventDefault();
      e.stopPropagation();

      if (!validateAll(true)) return;

      toggleCheckoutBtns(false);
      pushCartAttributes(0).then(function() {
        window.location.href = '/checkout';
      }).catch(function() {
        toggleCheckoutBtns(true);
        alert('Hubo un problema al guardar tus datos de facturación. Intenta de nuevo.');
      });
    }, true); // useCapture

    function init() {
      var docTypeRadios = document.querySelectorAll('input[name="attributes[billing_document_type]"]');
      if (!docTypeRadios.length) return;

      loadStateFromCart();
      showInvoiceFields();
      updateRadioVisuals();
      validateAll(false);

      docTypeRadios.forEach(function(r) {
        if (r.dataset.bfBound === 'true') return;
        r.dataset.bfBound = 'true';
        r.addEventListener('change', function() {
          updateRadioVisuals();
          showInvoiceFields();
          validateAll(false);
          saveBuffer();
          safePush();
        });
      });

      var els = getInputs();
      [els.rut, els.company, els.giro].forEach(function(inp) {
        if (!inp || inp.dataset.bfBound === 'true') return;
        inp.dataset.bfBound = 'true';

        if (inp.id === 'bf-rut') {
          inp.addEventListener('input', function(e) {
            e.target.value = fmtRut(e.target.value);
            saveBuffer();
            safePush();
          });
        } else {
          inp.addEventListener('input', function() {
            validateAll(false);
            saveBuffer();
            safePush();
          });
        }

        inp.addEventListener('blur', function(e) {
          e.target.dataset.hasBlurred = 'true';
          validateAll(false);
          pushCartAttributes(0).then(clearBuffer).catch(function() {});
        });
      });
    }

    document.addEventListener('DOMContentLoaded', init);

    ['shopify:section:load', 'cart:updated', 'ajaxCart:opened', 'cart-updated', 'add-to-cart'].forEach(function(ev) {
      document.addEventListener(ev, function() {
        setTimeout(init, 50);
      });
    });

    // BFCache (back/forward navigation)
    window.addEventListener('pageshow', function(e) {
      if (e.persisted) setTimeout(init, 50);
    });

    // El theme Tinker (KrownThemes) dispara el evento 'cart-updated' en el elemento
    // <cart-form> después de cualquier AJAX update del cart drawer. NO bubble a document,
    // por eso hay que bindear directo en <cart-form>. Confirmado por Ruben de KrownThemes
    // en ticket Nov 2024 — es el mecanismo oficial para re-inicializar custom code en el
    // cart drawer del theme. Sin esto, los listeners quedan en radios fantasma del DOM viejo.
    function bindKrownCartUpdated() {
      var cartForms = document.querySelectorAll('cart-form');
      for (var i = 0; i < cartForms.length; i++) {
        var cf = cartForms[i];
        if (cf.dataset.bfKrownBound === 'true') continue;
        cf.dataset.bfKrownBound = 'true';
        cf.addEventListener('cart-updated', function() {
          setTimeout(init, 50);
        });
      }
    }

    document.addEventListener('DOMContentLoaded', bindKrownCartUpdated);

    // Patrón de la versión legacy (v2) — en cada mutation del DOM, buscar radio del módulo
    // Y el <cart-form>. Si existen y no están bindeados, init() + bindKrownCartUpdated().
    new MutationObserver(function() {
      var el = document.querySelector('input[name="attributes[billing_document_type]"]');
      if (el && el.dataset.bfBound !== 'true') init();
      bindKrownCartUpdated();
    }).observe(document.body, { childList: true, subtree: true });

    // Push final si el usuario oculta el tab o cierra (visibilitychange + beforeunload)
    function flushKeepalive() {
      if (!isInvoice()) return;
      var attrs = buildAttrs();
      var formData = new FormData();
      Object.keys(attrs).forEach(function(k) {
        formData.append('attributes[' + k + ']', attrs[k]);
      });
      fetch('/cart/update.js', {
        method: 'POST',
        body: formData,
        keepalive: true,
        credentials: 'same-origin'
      }).catch(function() {});
    }

    document.addEventListener('visibilitychange', function() {
      if (document.hidden) flushKeepalive();
    });

    window.addEventListener('beforeunload', flushKeepalive);

  })();
}
